import { render, staticRenderFns } from "./show-phone.vue?vue&type=template&id=9fcde9cc"
import script from "./show-phone.vue?vue&type=script&lang=js"
export * from "./show-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports